import omitBy from "lodash/omitBy";
import isEmpty from "lodash/isEmpty";

export function excludeEmptyValues<T extends object>(object: T) {
  return omitBy<T>(object, isEmpty) as T;
}
